import React, { useRef } from 'react';
import { useState } from 'react';
import Hero from '../../images/savings-league/higher.png';

import { Grid, IconButton, Paper, Typography, Box, FormHelperText, TextField, Stack, Divider, Alert, AlertTitle, Button } from '@mui/material';
import ButtonComponent from '../../components/saving-league/buttonBottom';
export default function Higher() {




    return (
        <>
        <Grid container  sx={{background: '#1F162E',}} >
            <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} sx={{ background: '#1F162E',height:'100%' }}>
                <Grid item xs={12}>
                    <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/higher.png" alt="higher" style={{ width: '100%', }} />
                </Grid>
                <Grid item sx={12} pr={3} pl={3} pb={2} mt={4}>
                    <Typography
                        sx={{
                            color: "#FFF",
                            textAlign: "center",
                            fontFamily: "Metropolis",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "140%",
                            textTransform: "capitalize",
                            marginBottom: "8px",
                        }}

                    >
                        Higher the bill better the points
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: "Metropolis",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "140%",
                            color: "#fff",
                        }}

                    >
                        Spend big to earn big! Shop for at least ₹5000
                        a day and earn bonus points daily.
                    </Typography>
                </Grid>
                <Grid sx={{ marginTop: '16px', paddingX: '16px', display: 'flex' }} item xs={12}>
                    <Box sx={{ width: '65%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', background: 'linear-gradient(137.08deg, #5F51B4 4.31%, #2E234E 97.22%)', padding: '16px', }}>
                        <Typography sx={{ color: '#fff', fontFamily: 'Metropolis', fontSize: '14px', fontWeight: 600, lineHeight: '18px' }}>Min. Spend <br />₹10,000</Typography>
                    </Box>
                    <Box sx={{ width: '38%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(108deg, #FFE12F 9.19%, #FFBD59 100%)', marginLeft: '-10px', padding: '16px', textAlign: 'center' }}>
                        <Typography sx={{ color: '#000', fontFamily: 'Metropolis', fontSize: '12px', fontWeight: 500, lineHeight: '16.8px' }}>Bonus <br /> <Typography sx={{ color: '#301796', fontFamily: 'Metropolis', fontSize: '16.235px', fontWeight: 800, lineHeight: '22.729px', letterSpacing: '-0.487px' }}>200 Points</Typography></Typography>
                    </Box>
                </Grid>
                <Grid sx={{ marginTop: '16px', paddingX: '16px', display: 'flex' }} item xs={12}>
                    <Box sx={{ width: '65%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', background: 'linear-gradient(137.08deg, #5F51B4 4.31%, #2E234E 97.22%)', padding: '16px', }}>
                        <Typography sx={{ color: '#fff', fontFamily: 'Metropolis', fontSize: '14px', fontWeight: 600, lineHeight: '18px' }}>Min. Spend <br />₹7,500</Typography>
                    </Box>
                    <Box sx={{ width: '38%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(108deg, #FFE12F 9.19%, #FFBD59 100%)', marginLeft: '-10px', padding: '16px', textAlign: 'center' }}>
                        <Typography sx={{ color: '#000', fontFamily: 'Metropolis', fontSize: '12px', fontWeight: 500, lineHeight: '16.8px' }}>Bonus <br /> <Typography sx={{ color: '#301796', fontFamily: 'Metropolis', fontSize: '16.235px', fontWeight: 800, lineHeight: '22.729px', letterSpacing: '-0.487px' }}>150 Points</Typography></Typography>
                    </Box>
                </Grid>
                <Grid sx={{ marginTop: '16px', paddingX: '16px', display: 'flex' }} item xs={12}>
                    <Box sx={{ width: '65%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', background: 'linear-gradient(137.08deg, #5F51B4 4.31%, #2E234E 97.22%)', padding: '16px', }}>
                        <Typography sx={{ color: '#fff', fontFamily: 'Metropolis', fontSize: '14px', fontWeight: 600, lineHeight: '18px' }}>Min. Spend <br />₹5,000</Typography>
                    </Box>
                    <Box sx={{ width: '38%', borderRadius: '12px', height: '78px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(108deg, #FFE12F 9.19%, #FFBD59 100%)', marginLeft: '-10px', padding: '16px', textAlign: 'center' }}>
                        <Typography sx={{ color: '#000', fontFamily: 'Metropolis', fontSize: '12px', fontWeight: 500, lineHeight: '16.8px' }}>Bonus <br /> <Typography sx={{ color: '#301796', fontFamily: 'Metropolis', fontSize: '16.235px', fontWeight: 800, lineHeight: '22.729px', letterSpacing: '-0.487px' }}>100 Points</Typography></Typography>
                    </Box>
                </Grid>
                <Box sx={{ textAlign: 'center', marginTop: '24px', paddingBottom: '30%' }}>
                    <Typography sx={{ color: 'rgba(255, 255, 255, 0.80)', fontFamily: 'Metropolis', fontSize: '10px', fontFamily: 'metropolis', fontWeight: 600, lineHeight: '14px' }}>*Spending for the day is calculated at 11:59 PM daily</Typography>
                </Box>

                <a href='cashkaro://home'><ButtonComponent title="Shop Now" /></a>
            </Grid>


            <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

        </Grid>
        <style>
            {
                `
                body{background: #1f162e;}
                
                `
            }
        </style>
        </>
    )
};